import { API } from "@/main.js";
import Vue from "vue";

const getDefaultState = () => {
  return {
    dynamicObjectForms: {
      building: undefined,
      pathway: undefined,
      technicalPoint_pole: undefined,
      technicalPoint_manhole: undefined,
      technicalPoint_cabinet: undefined,
      technicalSite_centralOffice: undefined,
      technicalSite_manhole: undefined,
      technicalSite_cabinet: undefined,
      technicalLocal: undefined,
      closure: undefined,
      cluster: undefined,
      cable: undefined,
      tower: undefined
    }
  };
};

const state = getDefaultState();

const getters = {
  getFormStructureByObjectType: state => objectType => {
    return state.dynamicObjectForms[objectType];
  }
};

const mutations = {
  SET_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE(state, data) {
    if (state.dynamicObjectForms.hasOwnProperty(data.objectType))
      state.dynamicObjectForms[data.objectType] = data.structure;
  }
};

const actions = {
  FETCH_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.object_form.getByLayer(
        data.layer,
        data.needsTabs,
        data.needsFields,
        resp => {
          commit("SET_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE", {
            objectType: data.layer,
            structure: resp.data.data[0]
          });
          resolve(resp.data.data[0]);
        },
        error => {
          if (error.response && error.response.data) {
            Vue.toasted.global.toast_error(error.response.data.data);
          }
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/dynamicObjectForms.js